import React, { type FC, useCallback, type SyntheticEvent } from 'react';
import type { DocNode } from '@atlaskit/adf-schema';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { ReactRenderer } from '@atlaskit/renderer';
import { PortalCardClient } from '@atlassian/help-center-common-component/smart-card-client';
import type { AgentMessage as AgentMessageType } from '../../../../../common/types';

const RichTextRenderer: FC<{ adf: DocNode }> = ({ adf }) => {
    const smartCardClient = new PortalCardClient();
    const onLinkClick = useCallback((event: SyntheticEvent<HTMLAnchorElement>, url?: string) => {
        if (!url) return;

        event.preventDefault();
        window.open(url, '_blank');
    }, []);

    return (
        <SmartCardProvider client={smartCardClient}>
            <ReactRenderer
                document={adf}
                eventHandlers={{
                    link: { onClick: onLinkClick },
                }}
            />
        </SmartCardProvider>
    );
};

export const Content: FC<{ message: AgentMessageType['message'] }> = ({ message }) => {
    // In the future we will only render ADF
    // Currently BE will occasionly send markdown/strings which is handled here
    switch (message.contentMimetype) {
        case 'application/json+adf':
            return <RichTextRenderer adf={JSON.parse(message.content) as DocNode} />;
        case 'text/html':
            return <span dangerouslySetInnerHTML={{ __html: message.content }} />;
        default:
            return <>{message.content}</>;
    }
};
